// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1890":"2891b9cf","1967":"5ceea030","2070":"fac8622b","2395":"e727a60a","2407":"fac8622b","2883":"fac8622b","3023":"8343d7ff","4618":"fac8622b","6795":"e727a60a","6796":"fac8622b"}[chunkId] + ".chunk.css";
};